module.exports = __webpack_public_path__ + "assets/img/ability25.c0b95deb.png";